import React from 'react';
import { useSelector } from 'react-redux';
import Bullet from 'components/prism/bullet';

export const ObjectiveSummary = ({ objective, padBottom }) => {
    const { user } = useSelector(state => state.user);

    objective = {
        type: 'Writted Reflection',
        name: 'Assignment submission',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    };

    return (
        <a href="#" data-testid="course-item" className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}>
            <div className="prism-content">
                <div className="flex">
                    <div className="flex-grow">{objective.type}</div>
                    <div className="">
                        <Bullet value="Approved" icon="badge-check" style="success" />
                    </div>
                </div>
                <h3>{objective.name}</h3>
                {objective?.description && <p className="truncate-4">{objective.description}</p>}
            </div>
        </a>
    );
};

export default ObjectiveSummary;
